import { render, staticRenderFns } from "./ProgramClaimRewardWidget.vue?vue&type=template&id=4f78450b&scoped=true"
import script from "./ProgramClaimRewardWidget.vue?vue&type=script&lang=js"
export * from "./ProgramClaimRewardWidget.vue?vue&type=script&lang=js"
import style0 from "./ProgramClaimRewardWidget.vue?vue&type=style&index=0&id=4f78450b&prod&scoped=true&lang=css"
import style1 from "./ProgramClaimRewardWidget.vue?vue&type=style&index=1&id=4f78450b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f78450b",
  null
  
)

export default component.exports